import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

function DefaultPagination({ currentPage, totalPages, onPageChange }) {
  return(
    <Pagination size='sm'>
      <PaginationItem>
        <PaginationLink 
          first
          onClick={() => onPageChange(1)}
        />
      </PaginationItem>

      <PaginationItem>
        <PaginationLink
          previous
          onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        />
      </PaginationItem>
      {[...Array(totalPages)].map((_, index) => (
        <PaginationItem key={index} active={currentPage === index + 1}>
          <PaginationLink onClick={() => onPageChange(index + 1)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>
      ))}
      <PaginationItem>
        <PaginationLink
          next
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        />
      </PaginationItem>
      <PaginationItem>
        <PaginationLink
          last
          onClick={() => onPageChange(totalPages)}
        />
      </PaginationItem>
    </Pagination>
  );
}

export default DefaultPagination;